const aaa = [
	{
		path: "wuliaoList",
		component: () => import("@/views/wuliao/wuliao/wuliaoList.vue"),
		meta:{title:'门店资产',keepAlive:true},
	},
	{
		path: "invoiceAdd",
		component: () => import("@/views/wuliao/wuliao/invoiceAdd.vue"),
		meta:{title:'门店资产',keepAlive:false},
	},
	{
		path: "invoiceSee",
		component: () => import("@/views/wuliao/wuliao/invoiceSee.vue"),
		meta:{title:'门店资产',keepAlive:false},
	},
	{
		path: "assetsSee",
		component: () => import("@/views/wuliao/wuliao/assetsSee.vue"),
		meta:{title:'门店资产',keepAlive:false},
	},
	{
		path: "checkList",
		component: () => import("@/views/wuliao/check/checkList.vue"),
		meta:{title:'资产验收',keepAlive:true},
	},
	{
		path: "checkSee",
		component: () => import("@/views/wuliao/check/checkSee.vue"),
		meta:{title:'资产验收',keepAlive:false},
	},
	// 资产库存
	{
		path: "inventoryList",
		component: () => import("@/views/wuliao/inventory/inventoryList.vue"),
		meta:{title:'资产库存',keepAlive:false},
	},
	//Asset资产详情
	{
		path: "AssetList",
		component: () => import("@/views/wuliao/inventory/AssetList.vue"),
		meta:{title:'资产库存',keepAlive:false},
	},
	// acceptance调拨验收
	{
		path: "acceptanceList",
		component: () => import("@/views/wuliao/inventory/acceptanceList.vue"),
		meta:{title:'资产库存',keepAlive:false},
	},
	// 调拨验货
	{
		path: "inspectionList",
		component: () => import("@/views/wuliao/inventory/inspectionList.vue"),
		meta:{title:'资产库存',keepAlive:false},
	},
	// 资产调拨transfers
	{
		path: "transfersList",
		component: () => import("@/views/wuliao/inventory/transfersList.vue"),
		meta:{title:'资产库存',keepAlive:false},
	},
]
export default aaa;